import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import localePt from '@angular/common/locales/pt';

import { UiCopyButtonModule } from '@unico-people/shared/dashboard/ui-copy-button';

import { SalaryCollaboratorComponent } from './salary-collaborator.component';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  imports: [CommonModule, FormsModule, UiCopyButtonModule],
  declarations: [SalaryCollaboratorComponent],
  exports: [SalaryCollaboratorComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }]
})
export class SalaryCollaboratorModule {}
